import { GetInitializeSummaryRequestSchema, GetInitializeSummaryResponseSchema } from './get-initialize-summary.schema';
/**
 * Get Initialize Summary Contract
 * GET /api/v2/initialize/summary
 * Counts per building block for the wizard's overview step.
 */ export const getInitializeSummaryContract = {
    method: 'GET',
    path: '/api/v2/initialize/summary',
    description: 'Fetch initial-setup overview counts',
    requestSchema: GetInitializeSummaryRequestSchema,
    responseSchema: GetInitializeSummaryResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=get-initialize-summary.contract.js.map